import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { IoMdMale, IoMdFemale } from 'react-icons/io';
import { FaEdit } from 'react-icons/fa';
import dayjs from 'dayjs';
import tw from 'tailwind-styled-components';

import { getUserDataStagesService } from '../../../../services/externalv2_2';
import Checkbox from '../../../../components/Checkboxes/Checkbox';

const UserInfo: React.FC = () => {
  const params = useParams();
  const navigate = useNavigate();

  const [userDataStage, setUserDataStage] = useState<any>({ stages: [] });

  const getUserDataStages = () => {
    getUserDataStagesService(params.userid as string).then((data) => {
      setUserDataStage(data.results);
    });
  };

  useEffect(getUserDataStages, [params.userid]);

  return (
    <div className="flex flex-col gap-8 rounded-xl border border-stroke bg-white shadow-default p-8">
      <div className="flex flex-col gap-6">
        <div className="flex gap-2">
          <h1 className="text-black text-2xl font-bold">
            ข้อมูลส่วนบุคคล (id: {userDataStage?.user?.username})
          </h1>
        </div>

        <form className="grid grid-cols-2 gap-8 xl:px-30">
          <div className="flex flex-col">
            <Label>ชื่อ</Label>
            <Input type="text" value={userDataStage?.user?.name} disabled />
          </div>

          <div className="flex flex-col">
            <Label>นามสกุล</Label>
            <Input type="text" value={userDataStage?.user?.surname} disabled />
          </div>

          <div className="grid grid-cols-1 xl:grid-cols-2 gap-8">
            <div className="flex flex-col">
              <Label>ชื่อเล่น</Label>
              <Input type="text" value={userDataStage?.user?.nick} disabled />
            </div>

            <div className="flex flex-col">
              <Label>วันเกิด</Label>
              <Input
                type="text"
                value={dayjs(userDataStage?.user?.dob, 'DD-MM-YYYY')
                  .locale('th')
                  .format('D MMMM BBBB')}
                disabled
              />
            </div>
          </div>

          <div className="grid grid-cols-1 xl:grid-cols-4 gap-8">
            <div className="flex flex-col">
              <Label>อายุ</Label>
              <Input
                type="text"
                value={userDataStage?.user?.age_pres}
                disabled
              />
            </div>

            <div className="flex flex-col">
              <Label>เพศ</Label>
              <div className="mt-3"></div>
              {userDataStage?.user?.gend === 'male' && (
                <IoMdMale className="text text-blue-500" fontSize={24} />
              )}
              {userDataStage?.user?.gend === 'female' && (
                <IoMdFemale className="text text-purple-400" fontSize={24} />
              )}
            </div>

            <div className="flex flex-col col-span-2">
              <Label>ความบกพร่องทางการอ่าน</Label>
              <div className="mt-3">
                <Checkbox
                  label="มี"
                  id="isdylx"
                  isChecked={userDataStage?.user?.isdylx}
                  disabled
                />
              </div>
            </div>
          </div>

          <div className="flex flex-col">
            <Label>โรงเรียน</Label>
            <Input
              type="text"
              value={userDataStage?.user?.school?.sch_name}
              disabled
            />
          </div>

          <div className="flex flex-col">
            <Label>กลุ่ม</Label>
            <Input
              type="text"
              value={userDataStage?.user?.groupid?.group_name ?? '-'}
              disabled
            />
          </div>

          <div className="flex flex-col">
            <Label>วันที่เล่นเกม ครั้งสุดท้าย</Label>
            <Input
              type="text"
              value={
                userDataStage?.sscore?.timeStamp
                  ? dayjs(userDataStage?.sscore?.timeStamp)
                      .locale('th')
                      .format('D MMMM BBBB')
                  : '-'
              }
              disabled
            />
          </div>

          <div className="flex flex-col">
            <Label>รวม</Label>
            <Input
              type="text"
              value={`${
                Math.floor(userDataStage?.sscore?.sumDur / 3600) || 0
              } ชั่วโมง ${Math.floor(
                (userDataStage?.sscore?.sumDur % 3600) / 60 || 0,
              )} นาที`}
              disabled
            />
          </div>

          <div className="flex flex-col">
            <Label>ระดับชั้น</Label>
            <Input
              type="text"
              value={userDataStage?.user?.eduPres?.name_th}
              disabled
            />
          </div>
        </form>

        <div className="flex justify-center">
          <button
            type="button"
            className="flex gap-2 cursor-pointer rounded-lg border border-primary bg-primary p-2 text-white transition hover:bg-opacity-90"
            onClick={() =>
              navigate(
                `/sornthai/dashboard-parent/edit-student/${
                  userDataStage?.user?._id || params.userid
                }`,
              )
            }
          >
            <FaEdit className="self-center cursor-pointer hover:text-primary" />
            แก้ไขข้อมูล
          </button>
        </div>
      </div>
    </div>
  );
};

const Input = tw.input`w-full border-b border-stroke bg-transparent py-2 outline-none`;

const Label = tw.label`block font-bold text-black`;

export default UserInfo;
